import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
	'广州万周成方科技有限公司':'Guangzhou MyraSquare Technology Co.,Ltd.',
	'首页':'Home',
	'产品':'Product',
	'专利':'Patent',
	'新闻':'News',
	'关于':'About',
	'联系我们':'Contact Us',
	'搜索...':'Search...',
	'抗干扰 抗拒爆 安全高效':'Anti interference, anti explosion, safe and efficient',
	'首页介绍':"The company's products include multiple electronically controlled modules with international patent protection and matching leg wires with invention patents. Based on accumulated blasting experience in China's civil explosives industry, these two products incorporate innovative technologies and processes such as unique chip design, electronic ignition, large-capacity energy storage, blind-mating interfaces, and interference-fit waterproof structures. They are compatible with all mainstream detonator manufacturers' base detonators in China. When combined with base detonators, Wanzhou's products form finished digital electronic detonators that offer exceptional anti-interference and anti-detonation capabilities, ease of network integration and troubleshooting, as well as safe and efficient production and transportation. Particularly suited for specialized and complex project environments such as open-pit mines, underground engineering, and underwater operations, these detonators meet the demands of blasting scenarios in diverse global conditions.",
	'万周成方电子控制模块':'Wanzhou Chengfang Electronic Control Module',
	'万周成方电子控制模块介绍':'An electronic detonator control module and its matching leg wires produced under exclusive patent authorization.',
	'核心产品':'Core Product',
	'助力客户实现更高价值':'Assist customers in achieving higher value',
	'专利认证':'Patent Certification',
	'办公地点':'Office Location',
	'邮箱':'Email',
	'产品中心':'Product Center',
	'产品规格书':'Product Specification',
	'专利资质':'Patent Qualifications',
	'发明专利':'Invention Patent',
	'发明专利介绍':'An invention patent is the highest level of patent protection granted by the China National Intellectual Property Administration (CNIPA) in accordance with the law. It protects new technical solutions for products, methods, or improvements that demonstrate significant technological advancements.',
	'实用新型专利证书':'Utility Model Patent',
	'实用新型专利证书介绍':'A utility model patent is an official certificate issued by the China National Intellectual Property Administration (CNIPA) to patent applicants in accordance with the law.',
	'新闻资讯':'News Consultation',
	'企业新闻':'Corporate News',
	'查看更多':'View More',
	'查看详情':'View details',
	'关于我们':'About Us',
	'我们是谁':'Who we are',
	'我们是谁介绍':'Guangzhou MyraSquare Technology Co.,Ltd. is a company engaged in the import and export of goods, technology, and sales of electronic products. It was established in 2025 and is located in Guangzhou, Guangdong Province. The main product is an electronic detonator electronic control module and matching pin wire that has obtained exclusive patent authorization for production. Its patented technology is a new type of detachable digital electronic detonator, especially for special and complex project environments such as open-pit mines, underground engineering, and underwater engineering. It has strong anti-interference and explosion resistance performance, is easy to network inspection, and has the characteristics of safe and efficient production and transportation.',
	'合作伙伴':'Partner',
	'欢迎与我们联系':'Welcome to contact us',
	'国际':'International',
	'国内':'Domestic',
	...enLocale
}
export default en;


// WEBPACK FOOTER //
// ./src/utils/i18n/langs/en.js